<ng-container *ngIf="dwOption.dwCustomContent">
  <ng-template [ngTemplateOutlet]="dwOption.template"></ng-template>
</ng-container>
<ng-container *ngIf="!dwOption.dwCustomContent">
  {{dwOption.dwLabel}}
</ng-container>